// Phase 4 — pure helpers for permanent talent passives. Kept tiny and
// branch-free so the game's `useFrame` loop never sees a conditional.
//
// All multipliers are pre-computed ONCE at run start (in Game.jsx config
// useMemo) and never read by useFrame directly.

// All caps are per-talent maxLevel. Keeping in one place so balance tweaks
// are a single-file change.
const PER = {
  perm_ufo_speed:  { max: 5, per: 0.03 },
  perm_beam_range: { max: 5, per: 0.05 },
  perm_beam_pull:  { max: 5, per: 0.05 },
  coin_gain:       { max: 5, per: 0.05 },
  reduce_boss_dmg: { max: 5, per: 0.05 },
  start_coins:     { max: 5, per: 10 },
  better_lucky_run:{ max: 3, per: 1 },
  extra_revive:    { max: 3, per: 1 },
};

function lvl(tree, id) {
  const conf = PER[id];
  if (!conf) return 0;
  return Math.min(conf.max, Math.max(0, parseInt(tree?.[id] || 0, 10)));
}

/**
 * Compute all permanent talent multipliers/bonuses applied at run start.
 *
 * Returns a plain object so it can be spread into the Game config.
 * Pure function — safe to call inside `useMemo` with `talents` as a dep.
 */
export function computeTalentBonuses(talents) {
  const tree = talents || {};
  const tUfo   = lvl(tree, "perm_ufo_speed");
  const tBeamR = lvl(tree, "perm_beam_range");
  const tBeamP = lvl(tree, "perm_beam_pull");
  const tCoin  = lvl(tree, "coin_gain");
  const tBoss  = lvl(tree, "reduce_boss_dmg");
  const tStart = lvl(tree, "start_coins");
  const tLucky = lvl(tree, "better_lucky_run");
  const tRev   = lvl(tree, "extra_revive");

  return {
    ufoTalentMult:    1 + tUfo * PER.perm_ufo_speed.per,
    beamRangeTalent:  1 + tBeamR * PER.perm_beam_range.per,
    beamPullTalent:   1 + tBeamP * PER.perm_beam_pull.per,
    coinTalentMult:   1 + tCoin * PER.coin_gain.per,
    bossHpTalentMult: Math.max(0.5, 1 - tBoss * PER.reduce_boss_dmg.per),
    startCoinsBonus:  tStart * PER.start_coins.per,
    luckyRunBonus:    tLucky * PER.better_lucky_run.per,
    extraRevives:     tRev * PER.extra_revive.per,
  };
}
